import axios from "axios";
import {
    GET_AVAILABLE_TIMES_URL,
    GET_SUBZONES_URL,
    GET_ZONES_URL, LOGIN_URL,
    SCHEDULER_INSTALLATION_URL
} from "../../../services/apis/SchedulerUrl";
import {
    GET_AVAILABLE_TIMES,
    GET_SUB_ZONES,
    GET_ZONES,
    SCHEDULE_STARTS,
    SCHEDULE_STOPS,
    SCHEDULE_SUCCESS,
    START_LOADING_AVAILABLE_TIMES,
    START_LOADING_SUBZONE,
    STOP_LOADING_AVAILABLE_TIMES,
    STOP_LOADING_SUBZONE
} from "../../../services/types/SchedulerTypes";
import {toast} from "react-toastify";

const loginData = {
    email: 'sales.manager@tizeti.com',
            password: 'salesdept2021'
}
export const getZones = () => async dispatch => {

    try {

        const res = await axios.post(`${LOGIN_URL}`, loginData);

        if (res.data.status === "success") {

            try {

                const response = await axios.get(`${GET_ZONES_URL}`, {

                    headers: {

                        'Authorization' : `Bearer ${res.data._token}`

                    }

                });

                if(response.data){

                    dispatch({

                        type: GET_ZONES,
                        payload: response.data

                    })

                }

            } catch (e) {

                toast.info("Unable to get zones!")

            }

        }

     } catch (e) {

        toast.info("Unable to get zones!")

    }


};

export const getSubZones = data => async dispatch => {

    dispatch({

        type: START_LOADING_SUBZONE,
        payload: true

    });

    //add slash zone id
    try {

        const res = await axios.post(`${LOGIN_URL}`, loginData);

        if(res.data.status === "success"){

            try {

                const response = await axios.get(`${GET_SUBZONES_URL}/${data}`, {

                    headers: {

                        'Authorization' : `Bearer ${res.data._token}`

                    }
                });

                if(response.data){

                    dispatch({

                        type: GET_SUB_ZONES,
                        payload: response.data

                    })

                } else {

                    toast.info("Unable to get subzones");

                    dispatch({

                        type: STOP_LOADING_SUBZONE,
                        payload: false

                    });

                }


            } catch (e) {

                dispatch({

                    type: STOP_LOADING_SUBZONE,
                    payload: true

                });

                toast.info("Something went wrong! Please try again")

            }

        }

    } catch (e) {

        dispatch({

            type: STOP_LOADING_SUBZONE,
            payload: false

        });

        toast.info("Something went wrong! Please try again")

    }

};

export const getAvailableTimes = data => async dispatch => {

    dispatch({

        type: START_LOADING_AVAILABLE_TIMES,
        payload: true

    });

    const response = await axios.post(`${GET_AVAILABLE_TIMES_URL}`, data);

    if(response.data.length){

        dispatch({

            type: GET_AVAILABLE_TIMES,
            payload: response.data

        })

    } else {

        toast.info('no available times');
        dispatch({

            type: STOP_LOADING_AVAILABLE_TIMES,
            payload: false

        });

    }

};

export const scheduleInstallation = data => async dispatch => {

    dispatch({

        type: SCHEDULE_STARTS,
        payload: true

    });

    try {

        const loginToken = await axios.post(`${LOGIN_URL}`, loginData);

        if(loginToken.data._token){

            try {

                const response = await axios.post(`${SCHEDULER_INSTALLATION_URL}`, data, {

                    headers: {

                        'Authorization' : `Bearer ${loginToken.data._token}`
                    }

                });

                if(response.data.id){

                    toast.success("Installation has been scheduled!");
                    dispatch({

                        type: SCHEDULE_SUCCESS,
                        payload: "SUCCESS"

                    })

                }

            } catch (e) {

                if(e.response.data){

                    toast.info(e.response.data.message);

                    dispatch({

                        type: SCHEDULE_STOPS,
                        payload: false

                    });

                }

            }

        }

    } catch (e) {

        console.log(e);

    }

};